"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCollectorContainerFactory = exports.EventCollectorContentFactory = void 0;
const eventBus_1 = require("../eventBus");
const PostMessages_1 = require("./PostMessages");
const EventBusBridge_1 = require("./EventBusBridge");
const helpers_1 = require("./helpers");
class EventCollectorContentFactory {
}
exports.EventCollectorContentFactory = EventCollectorContentFactory;
EventCollectorContentFactory.init = (eventsMap, validDomain) => {
    if ((0, helpers_1.isLoadedInIFrame)()) {
        const eventBus = new eventBus_1.PostMessageEventBus(eventsMap, validDomain);
        const eventCollector = new PostMessages_1.ContentPostMessageEventCollector();
        eventCollector.init(eventBus);
        return eventBus;
    }
    const eventBus = new eventBus_1.ObserverEventBus(eventsMap);
    const eventCollector = new EventBusBridge_1.ContentEventBusEventBridgeCollector();
    eventCollector.init(eventBus);
    return eventBus;
};
class EventCollectorContainerFactory {
}
exports.EventCollectorContainerFactory = EventCollectorContainerFactory;
EventCollectorContainerFactory.initEventBridge = (eventsMap) => {
    const eventBus = new eventBus_1.ObserverEventBus(eventsMap);
    const eventCollector = new EventBusBridge_1.ContainerEventBusBridgeEventCollector();
    eventCollector.init(eventBus);
    return eventBus;
};
EventCollectorContainerFactory.initPostMessage = (eventsMap, validDomain) => {
    const eventBus = new eventBus_1.PostMessageEventBus(eventsMap, validDomain);
    const eventCollector = new PostMessages_1.ContainerPostMessageEventCollector();
    eventCollector.init(eventBus);
    return eventBus;
};
//# sourceMappingURL=factories.js.map